import React from 'react';
import MkIcon from './MkIcon';

const Cell = ({ value }) => {
  if (value === true) {
    return (
      <>
        <MkIcon name="check" className="mk-plan__yes" size={20} />
        <span className="screen-reader">Included</span>
      </>
    );
  }
  if (value === false) {
    return (
      <>
        <MkIcon name="dash" className="mk-plan__no" size={20} />
        <span className="screen-reader">Not included</span>
      </>
    );
  }
  return <span className="mk-plan__val">{value}</span>;
};

// rows: [{ feature, free, premium }] — true = included, false = not included, string = shown as is.
const MkPlanTable = ({ caption, rows }) => (
  <table className="mk-plan">
    <caption className="screen-reader">{caption}</caption>
    <thead>
      <tr>
        <th scope="col">
          <span className="screen-reader">Feature</span>
        </th>
        <th scope="col" className="mk-plan__free">
          Free
        </th>
        <th scope="col" className="mk-plan__premium">
          Premium
        </th>
      </tr>
    </thead>
    <tbody>
      {rows.map((row) => (
        <tr key={row.feature}>
          <th scope="row">{row.feature}</th>
          <td>
            <Cell value={row.free} />
          </td>
          <td>
            <Cell value={row.premium} />
          </td>
        </tr>
      ))}
    </tbody>
  </table>
);

export default MkPlanTable;
